import { useEffect, useRef } from 'react';
import 'video.js/dist/video-js.css';

interface VideoJsHandle {
  dispose: () => void;
}

interface VideoJsAdapterProps {
  onReady: () => void;
  src: string;
  type?: string;
}

export const VideoJsAdapter = ({
  onReady,
  src,
  type = 'video/mp4',
}: VideoJsAdapterProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const playerRef = useRef<VideoJsHandle | null>(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;
    let cancelled = false;

    import('video.js')
      .then(({ default: videojs }) => {
        if (cancelled) return;
        playerRef.current = videojs(
          videoElement,
          {
            autoplay: true,
            controls: true,
            fluid: false,
            muted: true,
            responsive: true,
            sources: [{ src, type }],
          },
          onReady,
        );
      })
      .catch((error: unknown) =>
        console.error('Video.js failed to load', error),
      );

    return () => {
      cancelled = true;
      playerRef.current?.dispose();
      playerRef.current = null;
    };
  }, [onReady, src, type]);

  return (
    <div className="video-js-frame" data-player-root>
      <div data-vjs-player>
        <video
          ref={videoRef}
          id="itg-player"
          className="video-js vjs-big-play-centered outline-none"
          controls
          autoPlay
          muted
          playsInline
        />
      </div>
    </div>
  );
};
